import {
  stateProp,
  actionProp,
  connectProps,
  createAction,
} from './utils';

import store from './store';

export {
  stateProp,
  actionProp,
  connectProps,
  createAction,
  store,
};



// WEBPACK FOOTER //
// ./src/store/index.js